import Heading from '@tiptap/extension-heading'

export const StarterKitCustomHeading = Heading.extend({
  priority: 100,
  addInputRules() {
    return [] // disable default input regex rules, which are the same as the reference
  },
})